import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { SiteAuditComponent } from './site-audit.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule
    ],
    declarations: [
        SiteAuditComponent
    ],
    providers: [],
    exports: []
})
export class SiteAuditModule {}
